<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    width?: string | number;
    height?: string | number;
    viewBox?: string;
    color?: string;
  }>(),
  {
    width: '25',
    height: '27',
    viewBox: '0 0 25 27',
    color: 'currentcolor',
  }
);
</script>
<template>
  <svg :width="props.width" :height="props.height" :viewBox="props.viewBox" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.29066 0L2.21254 6.79619V10.266H3.70232V7.7896H9.37717V1.44934H21.2947V10.2661H22.7876V6.38659e-05L8.29066 0Z"
      :fill="props.color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.70251 20.8519H21.2949V25.5495L3.70251 25.5337V20.8519ZM10.6869 13.2543H11.9283V17.9571H14.8639V19.0039H10.6869L10.6869 13.2543ZM4.57655 13.2543H6.04178L7.11196 15.1147L8.1905 13.2543H9.62666L7.82479 16.0166L9.75219 19.0037H8.24311L7.11199 17.0291L5.91632 19.0037H4.47127L6.38685 16.0681L4.57655 13.2543ZM18.0029 13.064C18.6705 13.064 19.3424 13.2464 19.8223 13.712C20.1563 14.0384 20.3279 14.4975 20.3437 14.9517H19.1661C19.1529 14.5692 18.8785 14.2045 18.4804 14.1312C18.0577 14.0499 17.5753 14.0315 17.1908 14.2535C16.83 14.4754 16.8389 15.0766 17.2347 15.2602C17.6986 15.5001 18.2337 15.5423 18.7297 15.6931C19.2486 15.8443 19.8245 15.9768 20.2019 16.3836C20.5517 16.8203 20.5973 17.4311 20.46 17.9522C20.2703 18.5647 19.6783 18.9746 19.054 19.1088C18.4342 19.257 17.7785 19.217 17.1592 19.0789C16.5415 18.9464 15.9951 18.5674 15.7756 17.9283C15.7163 17.758 15.6616 17.2804 15.6616 17.2804H16.8572C16.8436 17.7178 17.2137 18.0749 17.6324 18.1707C18.0757 18.2721 18.5784 18.2674 18.9856 18.051C19.3512 17.8581 19.4452 17.3204 19.1753 17.0184C18.8255 16.7079 18.3228 16.6971 17.8883 16.5801C17.2575 16.4288 16.5574 16.2865 16.1124 15.7898C15.7696 15.3787 15.7372 14.7981 15.8583 14.3038C16.0251 13.6422 16.6906 13.2311 17.3446 13.1192C17.5596 13.0815 17.7812 13.0614 18.0029 13.064ZM0.5 11.4141V20.8519H2.21226V26.98L22.7876 27L22.7877 20.8518H24.5V11.4139L0.5 11.4141Z"
      :fill="props.color"
    />
  </svg>
</template>
